<template>
    <div class="form-container">
        <h2>Update Take Home Criteria</h2>
        <hr>

        <form @submit.prevent="submitForm">
            <label>Absence of active substance use disorders, other physical or behavioral health conditions that
                increase the risk of patient harm as it relates to the potential for overdose, or the ability to
                function safely *</label>
            <div class="radio-group">
                <label><input type="radio" v-model="form.no_active_substance_disorder" :value="true" required>
                    Yes</label>
                <label><input type="radio" v-model="form.no_active_substance_disorder" :value="false" required>
                    No</label>
            </div>

            <label>Regularity of attendance for supervised medication administration *</label>
            <div class="radio-group">
                <label><input type="radio" v-model="form.regular_attendance" :value="true" required> Yes</label>
                <label><input type="radio" v-model="form.regular_attendance" :value="false" required> No</label>
            </div>

            <label>Absence of serious behavioral problems that endanger the patient, the public or others *</label>
            <div class="radio-group">
                <label><input type="radio" v-model="form.no_behavioral_issues" :value="true" required> Yes</label>
                <label><input type="radio" v-model="form.no_behavioral_issues" :value="false" required> No</label>
            </div>

            <label>Absence of known recent diversion activity *</label>
            <div class="radio-group">
                <label><input type="radio" v-model="form.no_diversion_activity" :value="true" required> Yes</label>
                <label><input type="radio" v-model="form.no_diversion_activity" :value="false" required> No</label>
            </div>

            <label>Whether take-home medication can be safely transported and stored *</label>
            <div class="radio-group">
                <label><input type="radio" v-model="form.can_safely_store_medication" :value="true" required>
                    Yes</label>
                <label><input type="radio" v-model="form.can_safely_store_medication" :value="false" required>
                    No</label>
            </div>

            <!-- <label>Other Considerations</label>
            <textarea v-model="form.other_considerations"></textarea> -->

            <div class="btn-group mt-4">
                <button type="submit" class="btn btn-sm">{{ isEditing ? 'Save' : 'Save' }}</button>
                <button type="button" class="btn btn-sm cancel-btn" @click="$router.back()">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['phase_determination_id', 'id'],
    data() {
        return {
            isEditing: false,
            form: {
                phase_determination_id: this.phase_determination_id,
                no_active_substance_disorder: true,
                regular_attendance: true,
                no_behavioral_issues: true,
                no_diversion_activity: true,
                can_safely_store_medication: true,
                other_considerations: '',
            },
        };
    },
    methods: {
        async submitForm() {
            try {
                if (this.isEditing) {
                    await this.$api.put(`/take-home-criteria/${this.id}`, this.form);
                } else {
                    await this.$api.post(`/take-home-criteria`, this.form);
                }
                this.$router.back();
            } catch (err) {
                alert('Something went wrong');
            }
        },
        async fetchData() {
            if (!this.id) return;
            this.isEditing = true;
            const res = await this.$api.get(`/take-home-criteria/${this.id}`);
            const data = res.data;

            this.form = {
                ...data,
                no_active_substance_disorder: Boolean(data.no_active_substance_disorder),
                regular_attendance: Boolean(data.regular_attendance),
                no_behavioral_issues: Boolean(data.no_behavioral_issues),
                no_diversion_activity: Boolean(data.no_diversion_activity),
                can_safely_store_medication: Boolean(data.can_safely_store_medication),
                other_considerations: data.other_considerations,
            };
        }

    },
    mounted() {
        this.fetchData();
    }
}
</script>

<style scoped>
.radio-group {
    display: flex;
    gap: 20px;
    margin-bottom: 10px;
}
</style>
